import PurshaseOrderRoutes from "./purchase-order";
import IntakeEstimateRoutes from "./intake-estimate";
import GridReportsRoutes from "./grid-reports";

export default [
  ...PurshaseOrderRoutes,
  ...IntakeEstimateRoutes,
  ...GridReportsRoutes,
];
